// Wszystkie zapytania profilu klientki siedzą pod wspólnym prefiksem `["trainee", traineeId]`,
// więc jedno `invalidateQueries({ queryKey: traineeKeys.all(id) })` odświeża całą kartę
// (np. po zamknięciu buildera, który pisze przez Redux). Nowe zapytania w profilu dokładaj
// jako `[...traineeKeys.all(id), "<nazwa>", ...]`.
export const traineeKeys = {
  all: (traineeId: string) => ["trainee", traineeId] as const,
  profile: (traineeId: string) => [...traineeKeys.all(traineeId), "profile"] as const,
  settings: (traineeId: string) => [...traineeKeys.all(traineeId), "settings"] as const,
  userStatus: (traineeId: string) => [...traineeKeys.all(traineeId), "userStatus"] as const,
  rating: (traineeId: string) => [...traineeKeys.all(traineeId), "rating"] as const,
  program: (traineeId: string, programId?: string | null) =>
    programId
      ? ([...traineeKeys.all(traineeId), "program", programId] as const)
      : ([...traineeKeys.all(traineeId), "program"] as const),
  // Realtime unieważnia poniższe prefiksy - zapytania o zdarzenia, ankiety i pomiary muszą je zachować.
  activityEvents: (traineeId: string) => [...traineeKeys.all(traineeId), "activityEvents"] as const,
  surveys: (traineeId: string) => [...traineeKeys.all(traineeId), "surveys"] as const,
  measurements: (traineeId: string) => [...traineeKeys.all(traineeId), "measurements"] as const,
};
